import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import { getEmbedPowerBiTokenAsync } from 'src/redux/async/ManageMentReport/ManageMentReport.async'

const initialState = {
  managementrepoertloader: false,
  PowerBIToken: [],
}
const getTheme = (reports, themeType) => {
  const theme = themeType === 0 ? 'dark' : 'light'
  const themeConfig = {
    dark: reports ? reports.find((report) => report.theme === 0) : null,
    light: reports ? reports.find((report) => report.theme === 1) : null,
  }
  const report = themeConfig[theme]
  return report && Boolean(report.accessToken)
    ? {
        accessToken: report.accessToken,
        embedUrl: report.embedUrl,
        reportId: report.reportId,
        expiry: report.expiry,
        reportName: report.reportName,
        white_json: report?.white_json || null,
        dark_json: report?.dark_json || null,
      }
    : {
        accessToken: null,
        embedUrl: null,
        reportId: null,
        expiry: null,
        reportName: null,
        white_json: null,
        dark_json: null,
      }
}

export const ManageMentReportSlice = createSlice({
  name: 'ManageMentReport',
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getEmbedPowerBiTokenAsync.pending), (state) => {
      state.managementrepoertloader = true
    })
    builder.addMatcher(isAnyOf(getEmbedPowerBiTokenAsync.fulfilled), (state, action) => {
      state.managementrepoertloader = false
      state.PowerBIToken = {
        dark: getTheme(action.payload.embedUrl, 0),
        light: getTheme(action.payload.embedUrl, 1),
      }
    })
    builder.addMatcher(isAnyOf(getEmbedPowerBiTokenAsync.rejected), (state, action) => {
      state.managementrepoertloader = false
    })
  },
  reducers: {
    PowerBITokenReset: () => initialState,
  },
})

export const { PowerBITokenReset } = ManageMentReportSlice.actions

export default ManageMentReportSlice.reducer
